import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'

const NachReportNACHFieldUpdateModalUI = ({
  context,
  successMsg,
  errorList,
  setErrorList,
  isOpen,
  updateKind,
  submitted,
  onSubmit,
  onCancelClick,
  selectedRecord,
  included,
  onIncludedChange,
  remarks,
  onRemarksChange,
  remarksError,
  setRemarksError,
  debitAmount,
  onDebitAmountChange,
  debitAmountError,
  setDebitAmountError,
  debitDate,
  onDebitDateChange,
  debitDateError,
  setDebitDateError,
}) => {
  const titleLabel =
    updateKind === 'decision'
      ? 'Update NACH Decision'
      : updateKind === 'included'
        ? 'Confirm NACH Inclusion'
        : updateKind === 'remarks'
          ? 'Update NACH remarks'
          : updateKind === 'debitAmount'
            ? 'Update NACH debit amount'
            : updateKind === 'debitDate'
              ? 'Update NACH debit date'
              : ''

  const buttonLabel = updateKind === 'included' ? 'Confirm' : 'Update'

  return (
    <ModalFormUI
      context={context}
      titleLabel={titleLabel}
      buttonLabel={buttonLabel}
      cancelLabel='Cancel'
      isOpen={isOpen}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >

      {updateKind === 'decision' && (
        <div>
          <div className='g_m_bottom_100'>
            <InputCheckBoxUI
              name='included'
              label='Include in NACH presentation'
              checked={included}
              onChange={onIncludedChange}
            />
          </div>
          <InputTextSF
            type='price'
            name='debitAmount'
            label='Debit amount (₹)'
            value={debitAmount}
            onChange={onDebitAmountChange}
            error={debitAmountError}
            setError={setDebitAmountError}
          />
          <div className='g_m_bottom_100'>
            <label className='g_block g_m_bottom_25'>Remarks</label>
            <input
              type='text'
              className='g_input'
              value={remarks}
              onChange={onRemarksChange}
              placeholder='Enter remark…'
              style={{ width: '100%' }}
            />
            {remarksError && <div className='g_text_danger g_small g_m_top_25'>{remarksError}</div>}
          </div>
        </div>
      )}

      {updateKind === 'included' && (
        <div>
          <p className='g_m_bottom_100' style={{ fontSize: '15px' }}>
            Do you want to include in NACH presentation?
          </p>
          <div className='g_m_bottom_100' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            <label style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px' }}>
              <input
                type='radio'
                name='includedOption'
                value='yes'
                checked={included === true}
                onChange={() => onIncludedChange && onIncludedChange(true)}
                style={{ marginRight: '8px', cursor: 'pointer' }}
              />
              Yes
            </label>
            <label style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px' }}>
              <input
                type='radio'
                name='includedOption'
                value='no'
                checked={included === false}
                onChange={() => onIncludedChange && onIncludedChange(false)}
                style={{ marginRight: '8px', cursor: 'pointer' }}
              />
              No
            </label>
          </div>
        </div>
      )}

      {updateKind === 'remarks' && (
        <div className='g_m_bottom_100'>
          <label className='g_block g_m_bottom_25'>Remarks</label>
          <input
            type='text'
            className='g_input'
            value={remarks}
            onChange={onRemarksChange}
            placeholder='Enter remark…'
            style={{ width: '100%', maxWidth: '360px' }}
          />
          {remarksError && <div className='g_text_danger g_small g_m_top_25'>{remarksError}</div>}
        </div>
      )}

      {updateKind === 'debitAmount' && (
        <InputTextSF
          type='price'
          name='debitAmount'
          label='Debit amount (₹)'
          value={debitAmount}
          onChange={onDebitAmountChange}
          error={debitAmountError}
          setError={setDebitAmountError}
        />
      )}

      {updateKind === 'debitDate' && (
        <InputTextSF
          name='debitDate'
          label='Debit date (YYYY-MM-DD)'
          value={debitDate}
          onChange={onDebitDateChange}
          error={debitDateError}
          setError={setDebitDateError}
        />
      )}
    </ModalFormUI>
  )
}

export default NachReportNACHFieldUpdateModalUI
